import AES from "crypto-js/aes";
import CryptoJSUtf8Enc from "crypto-js/enc-utf8";

import { store } from "../../index";

export const clearSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("auth-token");
  sessionStorage.removeItem("expiresOn");
  sessionStorage.removeItem("users");
  sessionStorage.removeItem("totalUser");
  sessionStorage.removeItem("storeLastUpdated");
}


export const getCredentialsIfValid = () => {
  let userDetailsState = store.getState().account.userAccountDetails;
  var currentEmail = null;
  let credentials = null;
  if(userDetailsState != null){
    currentEmail = userDetailsState.PetParentInfo.Email;
  }
  let params = new URL(document.location.toString()).searchParams;
  let userId = params.get("userId");
  var checkUsers = sessionStorage.getItem("users");
  if(checkUsers != null ){
    var users = JSON.parse(checkUsers);
    if(users.length > 1){
      
      users.map((item) =>{
        
        if(item.username == currentEmail || item.user == userId){
          let nowTimeStamp = new Date().getTime();
          if (parseInt(item.expiresOn) && nowTimeStamp <= item.expiresOn)
          {
            credentials =  item;
          }
        }}
      );
    }
    else{
      if(users.username == currentEmail || users.user == userId){
        let nowTimeStamp = new Date().getTime();
        if (parseInt(users.expiresOn) && nowTimeStamp <= users.expiresOn)
        { 
          credentials =  users;
        }
      }
    }
  }
  if(credentials == null){
  let expiryTimeStamp = sessionStorage.getItem("expiresOn");
  let nowTimeStamp = new Date().getTime();
  if (expiryTimeStamp && nowTimeStamp <= expiryTimeStamp) {
    let token = sessionStorage.getItem("token");
    if (token) {
      credentials = JSON.parse(token);
      
      return credentials;
    }
  }
  }
  return credentials;
  
};


export const getAuthToken = () => {
  let token = sessionStorage.getItem("auth-token");
  if (token) {
    return token;
  }
  return null;
}




export const saveCredentials = ({username, password, rememberMe}, authResponse) => {
   // Expiry TimeStamp Based on Auth API
   let expiryTimeStamp;
   // Better to use .issued timeStamp from API
   let currentTimeStamp = new Date().getTime();
   expiryTimeStamp = currentTimeStamp + authResponse.expires_in * 1000; // Converting seconds in API to milliseconds.
  let checkUser = sessionStorage.getItem("users");  
  var data = new Array();
  if(checkUser == null){
    data = {
      user:"u1",
      username,
      expiresOn:expiryTimeStamp,
      token:authResponse.access_token
    }
    sessionStorage.setItem("totalUser",1);
    sessionStorage.setItem("users",JSON.stringify(data));
  }
  else{
    var userCount = parseInt(sessionStorage.getItem("totalUser")) + 1;
    let newUser = {
        user:"u"+userCount,
        username,
        expiresOn:expiryTimeStamp,
        token:authResponse.access_token
    };
    data.push(JSON.parse(checkUser));
    data.push(newUser);
    sessionStorage.setItem("totalUser",userCount);
    sessionStorage.setItem("users",JSON.stringify(data));
  }

  let credentials = {
    username
  }
  let cipherText = JSON.stringify(credentials);
  sessionStorage.setItem("token", cipherText);
  sessionStorage.setItem("auth-token", authResponse.access_token);
  sessionStorage.setItem("auth-token", authResponse.access_token);
  sessionStorage.setItem("expiresOn", expiryTimeStamp);
};


